@if (text()) {
  <common-rich-text-view
    class="tt-compare-description_local-view"
    ttCommentableText
    [content]="text()"
    [elementId]="`${widget().uniqueId}-text`"
    [placeholder]="'SingleGuidelineManager.ImportedGuideline.Editor.NoDescription'"
    [references]="widget().references"
    [widgetId]="widget().uniqueId" />
}
